import { store } from "../../App";
import axios from "axios";
import dayjs from "dayjs";

export const fetchMemberships = async (data) => {
  try {
    const centerId = JSON.parse(localStorage.getItem("centerId")).centerId;

    const res = await axios.get(
      `/memberships?centerId=${centerId}&startDate=${dayjs().format("YYYY-MM-DD")}`
    );

    store.dispatch({ type: "FETCH_MEMBERSHIPS", data: res.data });
  } catch (e) {
    throw e;
  }
};

export const editMembership = (data) => {
  store.dispatch({ type: "EDIT_MEMBERSHIP", data });
};

export const fetchLastMembership = async (id) => {
  try {
    const res = await axios.get(`/memberships?last=true&userId=${id}`)
    if (res.data )
      return res.data
    else throw new Error()
  } catch (e) {
    throw e
  }
}